import { gql } from "@apollo/client";

export const GetStockUoM = gql`
  query GetStockUoM(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsStckUoMOrder
    $name: String
  ) {
    GetStockUoM(
      token: $token
      after: $after
      customer_id: $customer_id
      first: $first
      orderBy: $orderBy
      where: { or: [{ uomContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          uom
          slNo
          uomDesc
          useDecimals
          decimalNos
          customerID
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

//By Ids

export const GetStockUoMByNodeId = gql`
  query GetStockUoMByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsStckUoM {
        uom
        slNo
        uomDesc
        useDecimals
        decimalNos
        customerID
      }
    }
  }
`;
